export var onTouchStart = function (event, start) {
    var touch = event.touches[0] || event.changedTouches[0];
    start.x = touch.pageX;
    start.y = touch.pageY;
};
export var onTouchEnd = function (event, start, end) {
    var touch = event.touches[0] || event.changedTouches[0];
    end.x = touch.pageX;
    end.y = touch.pageY;
    var diff = {
        x: start.x - end.x,
        y: start.y - end.y,
    };
    start = { x: -1, y: -1 };
    end = { x: -1, y: -1 };
    return [diff, touch];
};
export var hasTouchSupport = function () { return matchMedia("(hover: none)").matches; };
